import React from 'react';
import { Box, IconButton } from '@mui/material';
import {
  FirstPage,
  LastPage,
  NavigateNext,
  NavigateBefore,
} from '@mui/icons-material';

const Pagination = ({ page, totalPages, onPageChange }) => {
  const handleFirstPage = () => {
    onPageChange(1);
  };

  const handlePreviousPage = () => {
    onPageChange(page - 1);
  };

  const handleNextPage = () => {
    onPageChange(page + 1);
  };

  const handleLastPage = () => {
    onPageChange(totalPages);
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
      <IconButton
        onClick={handleFirstPage}
        disabled={page === 1}
        size="small"
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={handlePreviousPage}
        disabled={page === 1}
        size="small"
      >
        <NavigateBefore />
      </IconButton>
      <Box component="span" mx={2}>
        Página {page} de {totalPages}
      </Box>
      <IconButton
        onClick={handleNextPage}
        disabled={page === totalPages}
        size="small"
      >
        <NavigateNext />
      </IconButton>
      <IconButton
        onClick={handleLastPage}
        disabled={page === totalPages}
        size="small"
      >
        <LastPage />
      </IconButton>
    </Box>
  );
};

export default Pagination;
